import React from 'react';
import PropTypes from 'prop-types';
import { Input, Icon } from '@components';

import { useHeaderContext } from '../../../../HeaderContext';

/**
 * Please note that this component contains id and classnames (which do not follow
 * CSS module naming strategy) that are required to show the search bar
 * implementation with Manomano-sf
 * i.e =>
 * 1) id = searchbar, searchbar-basic-wrapper, searchbar-basic-clear
 * 2) classes = searchbar__content--active
 */

const InputDesktop = ({ color, value, placeholder, onChange }) => {
  const { platformBaseUrl } = useHeaderContext();

  return (
    <div id="searchbar-basic-wrapper">
      <Input
        color={color}
        id="searchbar"
        autoComplete="off"
        name="q"
        type="text"
        data-qa="searchInputField"
        placeholder={placeholder}
        aria-label={placeholder}
        data-class-active="searchbar__content--active"
        data-autocomplete={`${platformBaseUrl}/autocomplete`}
        value={value}
        suffix={<Icon id="search" />}
        /**
          This closeIcon id is needed to cleanup the input for mobile version
        */
        closeIconId="searchbar-basic-clear"
        onChange={onChange}
      />
    </div>
  );
};

InputDesktop.propTypes = {
  color: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InputDesktop;
